import React from 'react';
import { BookCheck, CalendarDays, ShieldCheck, Sparkles, CircleCheck, Trophy } from 'lucide-react';
const highlights = [{
  icon: BookCheck,
  title: '60+ clases',
  subtitle: 'listas para dar'
}, {
  icon: CalendarDays,
  title: '6 tomos',
  subtitle: 'con progresión anual'
}, {
  icon: ShieldCheck,
  title: 'Cuerpo Seguro Pro™',
  subtitle: 'incluido sin costo'
}];
const includes = ['+240 páginas de contenido estructurado', 'Clases, variaciones y cueings listos para usar', 'Planificación, fidelización y comunicación', 'Adaptaciones para grupos reales y heterogéneos'];
const levels = [{
  n: '01',
  label: 'Principiante'
}, {
  n: '02',
  label: 'Intermedio'
}, {
  n: '03',
  label: 'Avanzado'
}, {
  n: '04',
  label: 'Adultos Mayores'
}, {
  n: '05',
  label: 'Movilidad'
}, {
  n: '06',
  label: 'Full Relax'
}];
export function SystemOverview() {
  return <section className="relative w-full overflow-hidden bg-[#04181E] font-heading" aria-labelledby="system-title" data-id="element-50" data-mp="2fd5z6nr347fx">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
      background: 'radial-gradient(75% 55% at 50% 10%, rgba(45,227,206,0.06) 0%, rgba(4,24,30,0) 70%)'
    }} data-id="element-51" data-mp="236mholdw9azb" />
      <div className="relative mx-auto max-w-[1120px] px-6 py-20 sm:px-8 lg:py-24" data-id="element-52" data-mp="2d53alnwe7zo0">
        {/* Badge */}
        <div className="flex justify-center" data-id="element-53" data-mp="2i2velgabbc8k">
          <span className="inline-flex items-center gap-3 rounded-full border border-[#2DE3CE]/45 bg-transparent px-6 py-3 text-[11px] font-bold uppercase tracking-[0.14em] text-white sm:text-[13px]" data-id="element-54" data-mp="1kgek0isyrcqi">
            <Trophy className="h-5 w-5 text-[#2DE3CE]" aria-hidden="true" strokeWidth={1.8} data-id="element-55" data-mp="1udixlu8qtzvp" />
            Sistema N°1 para profes en Argentina
          </span>
        </div>

        {/* Collection name */}
        <p className="mt-10 text-center text-[11px] font-bold uppercase tracking-[0.28em] text-[#2DE3CE] sm:text-sm" data-id="element-56" data-mp="11pwrae84sh55">
          Colección Profesional™
        </p>

        {/* Heading */}
        <h2 id="system-title" className="mt-4 text-center text-[2.25rem] font-extrabold uppercase leading-[1] tracking-[-0.02em] text-white sm:text-6xl lg:text-[4.5rem]" data-id="element-57" data-mp="ynii4ipug5t2">
          Stretching{' '}
          <span className="text-[#5EE7D3]" data-id="element-58" data-mp="18ck0gfjv2za7">
            Resuelto<span className="align-super text-[0.42em]" data-id="element-59" data-mp="13eihdumfqzyq">™</span>
          </span>
        </h2>

        <p className="mx-auto mt-6 max-w-[34ch] text-center text-lg leading-snug text-white/80 sm:max-w-[46ch] sm:text-2xl" data-id="element-60" data-mp="13guy64ggj4a7">
          Un método completo para planificar, enseñar y verte tan profesional como sos.
        </p>

        {/* Highlight cards */}
        <ul className="mt-10 grid grid-cols-3 items-stretch gap-3 sm:gap-5" data-id="element-61" data-mp="pnvjg4oi1e3p">
          {highlights.map(({
          icon: Icon,
          title,
          subtitle
        }) => <li key={title} className="flex min-h-[128px] flex-col items-center justify-center rounded-2xl border border-[#2DE3CE]/20 bg-[#062A31] px-3 py-5 text-center sm:min-h-[150px] sm:px-4" data-id="element-62" data-mp="kqdfkspc9p2k">
              <Icon className="h-5 w-5 text-[#5EE7D3] sm:h-6 sm:w-6" aria-hidden="true" strokeWidth={1.7} data-id="element-63" data-mp="23mferr72s251" />
              <p className="mt-3 text-[13px] font-bold leading-tight text-white sm:text-lg" data-id="element-64" data-mp="28mtcogeypvpc">{title}</p>
              <p className="mt-1 text-[11px] leading-snug text-white/55 sm:text-sm" data-id="element-65" data-mp="1unbxmsrgxwt6">{subtitle}</p>
            </li>)}
        </ul>

        {/* Main box */}
        <div className="mt-10 overflow-hidden rounded-[28px] border border-white/[0.07] bg-[#07242B]" data-id="element-66" data-mp="2mdgguo3hsdst">
          {/* Top block */}
          <div className="border-b border-white/[0.07] px-6 py-9 sm:px-10 sm:py-10" data-id="element-67" data-mp="2rb87zfwbbvvy">
            <h3 className="flex items-center gap-4 text-2xl font-bold text-white sm:text-3xl" data-id="element-68" data-mp="2dlo7kgq7fapt">
              <Sparkles className="h-8 w-8 shrink-0 text-[#2DE3CE]" aria-hidden="true" strokeWidth={1.8} data-id="element-69" data-mp="2hloms3l4npxx" />
              Todo lo que necesitás, listo
            </h3>
            <ul className="mt-7 flex flex-col divide-y divide-white/[0.05] border-y border-white/[0.05]" data-id="element-70" data-mp="3a2r73bn7upsp">
              {includes.map(item => <li key={item} className="flex items-center gap-3.5 py-3.5" data-id="element-71" data-mp="1mf8uhmmpyckc">
                  <CircleCheck className="h-[18px] w-[18px] shrink-0 text-[#2DE3CE]" aria-hidden="true" strokeWidth={1.8} data-id="element-72" data-mp="1hetgcsum511b" />
                  <span className="text-[13px] font-medium leading-none tracking-[-0.01em] text-white/85 sm:whitespace-nowrap sm:text-[15px]" data-id="element-73" data-mp="18fg8g4m50kip">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Bottom block */}
          <div className="px-6 py-9 sm:px-10 sm:py-10" data-id="element-74" data-mp="1vem36d30qx40">
            <p className="text-[12px] font-bold uppercase tracking-[0.22em] text-[#2DE3CE] sm:text-sm" data-id="element-75" data-mp="1vd190okm9g6o">
              Niveles y enfoques incluidos
            </p>
            <ul className="mt-6 grid grid-cols-2 gap-3 sm:gap-4" data-id="element-76" data-mp="2nwgkn0ecs2r6">
              {levels.map(({
              n,
              label
            }) => <li key={n} className="group flex min-w-0 items-center gap-3 rounded-xl border border-white/[0.07] bg-[#04191F] px-3 py-3 transition-colors hover:border-[#2DE3CE]/30 sm:px-4" data-id="element-77" data-mp="2j35g55x0jy2f">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-[#2DE3CE]/10 font-mono text-[11px] font-bold leading-none text-[#2DE3CE] sm:h-8 sm:w-8 sm:text-xs" data-id="element-78" data-mp="en0hu0e3fw9h">
                    {n}
                  </span>
                  <span className="min-w-0 truncate text-[13px] font-medium leading-none tracking-[-0.01em] text-white sm:text-[15px]" data-id="element-79" data-mp="okexvyw3uj19">
                    {label}
                  </span>
                </li>)}
            </ul>
            <p className="mt-7 text-[15px] leading-relaxed text-white/60 sm:text-lg" data-id="element-80" data-mp="12cbkxoix22qs">
              6 tomos conectados para que cada alumno avance, se sienta acompañado y quiera seguir.
            </p>
          </div>
        </div>
      </div>
    </section>;
}